import {
    CURRENT_SUBNET,
    DEFAULT_NETWORK,
    subnet_url,
} from '@/store/modules/network/network'
import axios from 'axios'
import {
    RawEVMBlockResponse,
    EVMBlockQueryResponse,
} from '@/store/modules/blocks/models'
import store from '@/store'

export interface IEVMBlockParam {
    height?: string
    hash?: string
}

const requestHeader = {
    'Content-Type': 'application/json',
}

export async function getEVMLatestBlock() {
    let VALIDATOR_URL: string
    if (CURRENT_SUBNET !== null) {
        VALIDATOR_URL = subnet_url
    } else {
        VALIDATOR_URL = DEFAULT_NETWORK.dcommGoEthUrl
    }
    const newRes = await axios.post(
        VALIDATOR_URL,
        JSON.stringify({
            jsonrpc: '2.0',
            method: 'eth_blockNumber',
            params: [],
            id: 1,
        }),
        {
            headers: requestHeader,
        }
    )

    return newRes
}

export async function getEVMBlockByHex(height: string) {
    const blockHex = parseInt(height).toString(16)

    const payload = JSON.stringify({
        jsonrpc: '2.0',
        method: 'eth_getBlockByNumber',
        params: [`0x${blockHex}`, true],
        id: 1,
    })

    store.dispatch('Blocks/sendMessage', payload)
}

export async function getEVMBlockByHash(hash: string) {
    let VALIDATOR_URL: string
    if (CURRENT_SUBNET !== null) {
        VALIDATOR_URL = subnet_url
    } else {
        VALIDATOR_URL = DEFAULT_NETWORK.dcommGoEthUrl
    }
    const payload = JSON.stringify({
        jsonrpc: '2.0',
        method: 'eth_getBlockByHash',
        params: [hash, true],
        id: 1,
    })

    store.dispatch('Blocks/sendMessage', payload)
}

/**
 * Get an EVM block (ACT-Chain)
 * @param id block height
 * @link https://docs.dcm.network/build/tools/indexer#get-a-ACT-Chain-block
 */
export async function getEVMBlock(param: IEVMBlockParam, fromBlocks = false) {
    let response
    if (param.height) response = await getEVMBlockByHex(param.height)
    else if (param.hash) response = await getEVMBlockByHash(param.hash)
    else response = await getEVMBlockByHex('0') //fallback

    if (!fromBlocks) {
        store.state.Blocks.socket.addEventListener('message', function (event) {
            const data: any = { data: JSON.parse(event.data) }
            const blockData = data
            const rawBlockData: RawEVMBlockResponse = blockData.data.result

            const parsedBlock: EVMBlockQueryResponse = {
                ...rawBlockData,
                blockNumber: parseInt(rawBlockData.number, 16).toString(),
                header: {
                    ...rawBlockData,
                },
            }
            return parsedBlock
        })
    }
}

export async function getEVMBlockByHexHttp(height: string) {
    let VALIDATOR_URL: string

    if (CURRENT_SUBNET !== null) {
        VALIDATOR_URL = subnet_url
    } else {
        VALIDATOR_URL = DEFAULT_NETWORK.dcommGoEthUrl
    }
    const blockHex = parseInt(height).toString(16)

    const newRes = await axios.post(
        VALIDATOR_URL,
        JSON.stringify({
            jsonrpc: '2.0',
            method: 'eth_getBlockByNumber',
            params: [`0x${blockHex}`, true],
            id: 1,
        }),
        {
            headers: requestHeader,
        }
    )
    return newRes
}

export async function getEVMBlockByHashHttp(hash: string) {
    let VALIDATOR_URL: string
    if (CURRENT_SUBNET !== null) {
        VALIDATOR_URL = subnet_url
    } else {
        VALIDATOR_URL = DEFAULT_NETWORK.dcommGoEthUrl
    }
    const newRes = await axios.post(
        VALIDATOR_URL,
        JSON.stringify({
            jsonrpc: '2.0',
            method: 'eth_getBlockByHash',
            params: [hash, true],
            id: 1,
        }),
        {
            headers: requestHeader,
        }
    )
    return newRes
}
